import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, IconButton, Tooltip, Typography, Box, Slide } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { keyframes } from "@emotion/react";

const pulse = keyframes`
  0% { transform: scale(1); color: #6A1B9A; }
  50% { transform: scale(1.3); color: #AB47BC; }
  100% { transform: scale(1); color: #6A1B9A; }
`;

const PromptHelpDialog = ({ title, content }) => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Tooltip title="Click for guidance" arrow>
                <IconButton
                    onClick={() => setOpen(true)}
                    size="small"
                    sx={{
                        ml: 1,
                        animation: `${pulse} 2.5s infinite ease-in-out`,
                        "&:hover": { animation: "none", color: "#AB47BC" }
                    }}
                >
                    <InfoOutlinedIcon fontSize="small" />
                </IconButton>
            </Tooltip>

            <Dialog open={open} onClose={() => setOpen(false)} TransitionComponent={Slide} keepMounted>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent dividers>
                    <Box>
                        {content}
                    </Box>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default PromptHelpDialog;
